import { env } from '../../../../../../env';
import './PromoContent.css';
import styles from '../../CertificationSection.module.css';

const PromoContent = () => {
  return (
    <div>
      <div className={styles.title}>Why Get Certified?</div>
      <div><iframe className="iframe-container" src={env.REACT_APP_CERTIFICATE_PROMO_URL}></iframe></div>
      <div className='iframe-content'>
        Earning your SHRM-CP or SHRM-SCP credential makes you a recognized expert and leader in the HR field and a valuable asset to your organization, keeping your organization more competitive in today's economy.
      </div>
      <div><a className="btn-learn" target="_blank" href="https://www.shrm.org/credentials/certification">Learn More</a></div>
    </div>
  );
};

export default PromoContent;

